"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeHumidity = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.relativeHumidity = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'relativeHumidity',
    variableName: VariableName_1.VariableName.relativeHumidity,
    dbTable: tsdb_1.TSDBTable.relativeHumidity,
    title: 'Humidity',
    icon: free_solid_svg_icons_1.faTint,
    isSlotted: true,
    order: 3,
    graphQLSampleKey: 'humidity',
    bucketing: {
        min: 0,
        max: 100,
        numberOfBuckets: 10,
    },
    colormap: [
        { value: 0, rgb: [255, 0, 255, 1] },
        { value: 40, rgb: [255, 204, 0, 1] },
        { value: 50, rgb: [0, 255, 0, 1] },
        { value: 60, rgb: [35, 201, 231, 1] },
        { value: 100, rgb: [0, 0, 255, 1] },
    ],
    dataPointConverter: x => x,
    unit: '%',
    decimals: 1,
};
//# sourceMappingURL=relative-humidity.js.map